// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__FZiSa","overflowing":"ReadFullNote_overflowing__3-jnS"};